var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoAlphamind(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 161,
    height: 43,
    viewBox: "0 0 161 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.75 7.56567H127.307V20.4235H129.75V7.56567Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M142.959 18.1015H142.879L134.68 7.56567H131.761V20.421H134.128V11.1574L141.377 20.421H145.325V7.56567H142.959V18.1015Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M160.996 13.9607C160.89 9.78118 158.131 7.64789 152.718 7.56323H147.355V20.4186H152.795C158.367 20.5033 161.102 18.3506 160.996 13.9607ZM152.638 17.8838H149.799V9.8876H152.638C156.37 9.97225 158.287 10.8672 158.393 13.9607C158.393 17.2646 156.476 17.8838 152.638 17.8838Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.924 17.5404L112.061 7.87285H109.188L102.82 20.5371H104.096V20.5517H111.945V18.3942H106.506L110.628 9.93358C111.521 12.1539 115.79 20.5396 115.79 20.5396H118.432C118.432 20.5396 122.294 10.8527 122.61 9.89246L122.689 20.4259H125.133V7.56567H121.032L116.924 17.5404Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4635 7.8728L45.0952 20.5371H46.3713V20.5516H54.2207V18.3941H48.7811L52.9036 9.93353C53.7961 12.1539 58.0658 20.5395 58.0658 20.5395H60.7072L54.3389 7.87522H51.4635V7.8728Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M98.6329 13.2471H90.1659V7.8728H87.7585V20.5371H90.1659V15.3683H98.6329V20.5371H101.117V7.8728H98.6329V13.2471Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.6346 7.8728H73.8779V20.5371H76.3625V15.7795H80.4006C84.2843 15.7384 86.2527 14.3791 86.3033 11.7016C86.0983 9.27323 84.2071 7.99616 80.6346 7.8728ZM80.0918 13.9921H76.3625V9.41593H80.0918C82.4221 9.45705 83.6378 10.2407 83.7415 11.7645C83.6885 13.3705 82.4727 13.951 80.0918 13.9921Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9372 7.8728H61.5298V20.5371H72.4041V18.3917H63.9372V7.8728Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7038 9.23218C30.7685 9.23218 30.01 9.99062 30.01 10.926C30.01 11.8613 30.7685 12.6197 31.7038 12.6197C32.6391 12.6197 33.3976 11.8613 33.3976 10.926C33.3976 9.99062 32.6391 9.23218 31.7038 9.23218Z",
    fill: "url(#paint0_linear_0_1680)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9523 16.6543C35.5832 16.6543 34.4758 17.7641 34.4758 19.1307C34.4758 20.4998 35.5856 21.6072 36.9523 21.6072C38.3189 21.6072 39.4287 20.4974 39.4287 19.1307C39.4287 17.7641 38.3189 16.6543 36.9523 16.6543Z",
    fill: "url(#paint1_linear_0_1680)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8933 13.686C24.1825 13.686 22.7941 15.0745 22.7941 16.7852C22.7941 18.496 24.1825 19.8844 25.8933 19.8844C27.604 19.8844 28.9925 18.4984 28.9925 16.7852C28.9925 15.0745 27.6064 13.686 25.8933 13.686Z",
    fill: "url(#paint2_linear_0_1680)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1573 36.7203C27.836 31.8789 20.3969 17.277 18.5553 13.7513C22.4299 9.97851 26.0986 5.68228 28.6114 2.58792C28.7253 2.62185 28.844 2.63881 28.9676 2.63881C29.6775 2.63881 30.2543 2.0621 30.2543 1.35212C30.2543 0.642138 29.6775 0.0654297 28.9676 0.0654297C28.2576 0.0654297 27.6809 0.642138 27.6809 1.35212C27.6809 1.53386 27.7196 1.7059 27.7851 1.86098C25.1535 4.9311 21.5552 8.8154 17.9229 12.3483C15.3689 7.55779 13.5491 4.81479 11.4725 3.51599C10.1615 2.69696 8.03887 2.76966 6.17305 4.28412C1.73869 7.88007 -0.413057 14.3596 1.33403 19.2979C1.98343 21.1298 3.41309 21.8955 4.97844 22.1064C8.35146 22.5667 12.2188 20.4538 16.8979 16.0073C18.8606 19.7947 24.8797 31.4185 27.8166 37.646C27.2714 38.2057 26.9346 38.9666 26.9346 39.8098C26.9346 41.5206 28.323 42.909 30.0338 42.909C31.7445 42.909 33.133 41.523 33.133 39.8098C33.133 38.1427 31.8099 36.7858 30.1573 36.7203ZM8.93059 19.0847C7.78444 19.5378 4.75551 20.2963 3.79352 16.8796C3.40339 15.4912 3.40824 11.2749 5.40491 8.43255C6.69403 6.59823 8.7125 4.52401 11.0096 6.51342C12.7083 7.98426 13.7236 10.2087 15.8099 14.1536C12.7252 17.0856 11.1865 18.193 8.93059 19.0847Z",
    fill: "url(#paint3_linear_0_1680)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_1680",
    x1: 3.9705,
    y1: -4.46499,
    x2: 42.3015,
    y2: 16.8087,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#954AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_0_1680",
    x1: 1.72487,
    y1: -0.418861,
    x2: 40.0559,
    y2: 20.8549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#954AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_0_1680",
    x1: 0.116826,
    y1: 2.47899,
    x2: 38.4478,
    y2: 23.7527,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#954AAC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_0_1680",
    x1: -1.08567,
    y1: 4.64432,
    x2: 37.2453,
    y2: 25.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A8CE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#954AAC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAlphamind);
export default __webpack_public_path__ + "static/media/logo_alphamind.d039a2e3ca2cc4100879078c22565862.svg";
export { ForwardRef as ReactComponent };